import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import down from "../../../assets/img/down.png";
import { useUserApi, useLanguageApi } from "../../../Hooks";
import { getInitialLanguage } from "../../../Utils/getInitialLanguage";

const LanguageSelector = ({ onLanguageChange }) => {
  const { i18n, t } = useTranslation();
  const [language, setLanguage] = useState(getInitialLanguage());
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [languages, setLanguages] = useState([]);
  const userApi = useUserApi();
  const languageApi = useLanguageApi();

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language, i18n]);

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const response = await languageApi.getLanguages();
        setLanguages(response);
      } catch (error) {
        console.error("Erro ao buscar idiomas:", error);
      }
    };

    fetchLanguages();
  }, []);

  const handleLanguageChange = async (langCode) => {
    const selectedLang = languages.find((lang) => lang.code === langCode);
    if (!selectedLang) return;

    setLanguage(langCode);
    i18n.changeLanguage(langCode);
    localStorage.setItem("language", langCode);
    localStorage.setItem("languageId", selectedLang.id);
    onLanguageChange?.(langCode);
    setDropdownOpen(false);

    try {
      const email = localStorage.getItem("email");
      const token = localStorage.getItem("tokenClass");
      if (email && token) {
        await userApi.updateUserLanguage(email, token, langCode);
      }
    } catch (err) {
      console.error("Erro ao atualizar idioma na API", err);
    }
  };

  const currentLang = languages.find((lang) => lang.code === language);

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="relative inline-block text-left">
        <div
          className="flex items-center space-x-2 cursor-pointer"
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          <div className="w-10 h-10 rounded-full border-2 border-black flex items-center justify-center bg-white">
            {currentLang && (
              <img src={currentLang.flagURL} alt={currentLang.name} className="w-6 h-6" />
            )}
          </div>
          <img src={down} alt={t("dropdownAlt")} className="w-4 h-4" />
        </div>
        {dropdownOpen && (
          <div className="absolute right-0 bottom-full mb-2 w-36 bg-white border rounded shadow">
            {languages.map((lang) => (
              <div
                key={lang.id}
                className="flex items-center px-2 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleLanguageChange(lang.code)}
              >
                <img src={lang.flagURL} alt={lang.name} className="w-6 h-6 mr-2" />
                <span>{lang.name}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSelector;
